import OnDev from "../../components/PageOnDev/OnDev";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <OnDev/>
    </div>
  );
}
